import React, { useState } from 'react';

interface DatabaseTable {
  id: string;
  name: string;
  displayName: string;
  description: string;
  icon: string;
}

interface DatabaseTablesSidebarProps {
  tables: DatabaseTable[];
  onTableSelect: (table: DatabaseTable) => void;
  selectedTable: DatabaseTable | null;
}

const DatabaseTablesSidebar: React.FC<DatabaseTablesSidebarProps> = ({ 
  tables, 
  onTableSelect, 
  selectedTable 
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredTables = tables.filter(table =>
    table.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    table.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-2">
      {/* Header - Match tournament section styling */}
      <div className="text-base font-semibold text-gray-900 mb-2">Database Tables</div>
      
      {/* Search - Match tournament section search styling */}
      <div className="relative">
        <input
          type="text"
          placeholder="Search tables..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      {/* Database Tables List - Match tournament section font sizes exactly */}
      <div className="space-y-1">
        {filteredTables.map((table) => (
          <button
            key={table.id}
            onClick={() => onTableSelect(table)}
            className={`w-full flex items-center justify-between px-2 py-1 text-xs text-gray-600 hover:bg-gray-50 rounded-lg transition-colors ${
              selectedTable?.id === table.id ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            <div className="flex items-center space-x-2">
              <span>{table.icon}</span>
              <span className="truncate">{table.displayName}</span>
            </div>
          </button>
        ))}
      </div>

      {filteredTables.length === 0 && searchQuery && (
        <div className="text-center py-4">
          <p className="text-sm text-gray-500">No tables found</p>
        </div>
      )}
    </div>
  );
};

export default DatabaseTablesSidebar;
